
<h1 class="contact-list-header">
  Aviation Contact List
</h1>

<div class="contacts-list-container">
  <mat-list class="contacts-list-items">
    @if (loading) {
      <mat-spinner class="spinner" color="accent"></mat-spinner>
    }
    @for (user of userList; track user; let i = $index; let first = $first) {
      <mat-list-item class="contacts-list-item" lines="2">
        @if (first) {
          <h3 #jumpToLetter matLine
            id="alpha{{user.sortLetter}}">
            {{user.sortLetter}}
          </h3>
        }
        @if (!first && userList[i].sortLetter != userList[i-1].sortLetter) {
          <h3 #jumpToLetter matLine
            id="alpha{{user.sortLetter}}">
            {{user.sortLetter}}
          </h3>
        }
        <a matLine [routerLink]="['/user-profile']" [queryParams]="{userinfoid: user.id}">
          <span class="lname">{{user.firstName}}</span>  {{user.lastName}}
        </a>
        <mat-divider></mat-divider>
      </mat-list-item>
    }

    @if (!loading) {
      <mat-list-item>
        <span id="allTotal">{{ totalContacts }} Contacts</span>
      </mat-list-item>
    }
  </mat-list>

  <div class="contacts-list-alphabet-container">
    <mat-list class="alphabet-list">
      @for (nav of alphaNav; track nav) {
        <a mat-list-item class="alphabet-item" routerLink="." (click)="ScrollContactsTo('alpha' + nav)">{{nav}}</a>
      }

      <mat-list-item class="alphabet-item">
        <a routerLink="." (click)="ScrollToID('allTotal')">#</a>
      </mat-list-item>
    </mat-list>
  </div>
</div>